import { render } from "./SettingsClientComponent.vue?vue&type=template&id=38fd06cb&scoped=true"
import script from "./SettingsClientComponent.vue?vue&type=script&lang=js"
export * from "./SettingsClientComponent.vue?vue&type=script&lang=js"

import "./SettingsClientComponent.vue?vue&type=style&index=0&id=38fd06cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fd06cb"]])

export default __exports__